<div class="container">
    <h2>System Settings</h2>

    <div *ngIf="isLoading" class="text-center py-5">
        <img width="50px" height="50px" src="assets/img/backoffice/loading.gif" />
    </div>

    <div *ngIf="!isLoading" class="table-responsive">
        <table class="table table-hover">
            <thead class="bg-green-light">
                <tr>
                    <th>Name</th>
                    <th>Value</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let setting of settings">
                    <td>
                        <strong>{{ setting.title || setting.name }}</strong>
                        <i class="fa fa-question-circle ml-1 text-primary"
                            [ngbPopover]="setting.description"
                            popoverTitle="Description"
                            triggers="click"
                            container="body"
                            style="cursor: pointer;">
                        </i>
                    </td>
                    <td>
                        <span *ngIf="editingSetting?.id !== setting.id">{{ displayValue(setting) }}</span>
                        <textarea *ngIf="editingSetting?.id === setting.id && !isBooleanType(setting.type) && isLongText(setting)"
                            [(ngModel)]="editValue"
                            class="form-control"
                            rows="4"
                            style="width: 350px">
                        </textarea>
                        <input *ngIf="editingSetting?.id === setting.id && !isBooleanType(setting.type) && !isLongText(setting)"
                            [type]="getInputType(setting.type)"
                            [step]="getStep(setting.type)"
                            [(ngModel)]="editValue"
                            class="form-control"
                            style="width: 200px">
                        <div *ngIf="editingSetting?.id === setting.id && isBooleanType(setting.type)" class="form-check">
                            <input type="checkbox"
                                [checked]="editValue === '1'"
                                (change)="editValue = editValue === '1' ? '0' : '1'"
                                class="form-check-input"
                                id="checkbox-{{ setting.id }}">
                            <label class="form-check-label" for="checkbox-{{ setting.id }}">
                                {{ editValue === '1' ? 'Enabled' : 'Disabled' }}
                            </label>
                        </div>
                    </td>
                    <td>
                        <span *ngIf="editingSetting?.id !== setting.id">
                            <button class="btn btn-sm btn-accept" (click)="startEdit(setting)">
                                <i class="fa fa-edit"></i> Edit
                            </button>
                        </span>
                        <span *ngIf="editingSetting?.id === setting.id">
                            <button class="btn btn-sm btn-success mr-1" (click)="saveSetting()" [disabled]="isSaving">
                                <i class="fa fa-save"></i> Save
                            </button>
                            <button class="btn btn-sm btn-secondary" (click)="cancelEdit()">
                                <i class="fa fa-times"></i> Cancel
                            </button>
                            <i *ngIf="isSaving" class="fa fa-spinner fa-spin ml-2"></i>
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
